<template>
  <div class="section-toggle">
    <button
      v-for="(section, index) in sections"
      :key="'section-toggle-' + index"
      :class="{ active: section.id === value }"
      @click="$emit('input', section.id)"
    >
      <span v-if="section.icon"><v-icon :name="section.icon"/></span>
      {{ section.title }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    sections: {
      type: Array,
      required: true
    },
    value: {
      type: String
    }
  }
};
</script>

<style scoped lang="less">
@import "../styles/vars";
.section-toggle {
  display: flex;
  flex-direction: row;
  button {
    background-color: transparent;
    color: #aaa;
    span {
      margin-right: 0.5em;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &.active {
      color: #333;
    }
  }
}
</style>
